import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loaded } from "../redux/todos/actions";
import fetchTodos from "../redux/todos/thunk/fetchTodos";
import CompleteTodo from "./CompleteTodo";
import Todo from "./Todo";

export default function CompleteTodoL() {
  const todos = useSelector((state) => state.todo);
  const filters = useSelector((state) => state.filter);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTodos);
  }, [dispatch]);

  return (
    <div class="mt-1 text-gray-700 text-sm max-h-[120px] overflow-y-auto">
      {todos
        .filter((data) => data.completed)
        .filter((data) => {
          const { status } = filters;
          switch (status) {
            case "complete":
              return data.completed;
            case "incomplete":
              return !data.completed;
            default:
              return true;
          }
        })
        .filter((data) => {
          const { colors } = filters;
          if (colors.length > 0) {
            return colors.includes(data.color);
          }
          return true;
        })
        .map((todo) => (
          <CompleteTodo todo={todo} />
        ))}
    </div>
  );
}
